(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var wrapper = document.querySelector(".zero-features-wrapper");
  if (!wrapper) return;

  var enableDesktop = wrapper.getAttribute("data-desktop-slider") === "true";
  var enableMobile = wrapper.getAttribute("data-mobile-slider") === "true";
  var desktopCols = wrapper.getAttribute("data-desktop-columns");
  var mobileCols = wrapper.getAttribute("data-mobile-columns");
  var featureList = wrapper.querySelector(".zero-features-list");

  function initFlickity(slider) {
    if (!slider.classList.contains("flickity-enabled")) {
      slider.flickityInstance = new Flickity(slider, {
        cellAlign: "center",
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        groupCells: true
      });
    }
  }

  function destroyFlickity(slider) {
    if (slider.flickityInstance) {
      slider.flickityInstance.destroy();
      slider.flickityInstance = null;
    }
  }

  function checkSlider() {
    var isMobile = window.innerWidth < 768;

    if (isMobile && enableMobile) {
      featureList.style.display = "block";
      initFlickity(featureList);
    } else if (!isMobile && enableDesktop) {
      featureList.style.display = "block";
      initFlickity(featureList);
    } else {
      // Destroy flickity and show grid
      destroyFlickity(featureList);
      featureList.classList.remove("flickity-enabled");
      featureList.style.display = "grid";
      featureList.style.gridTemplateColumns = isMobile 
        ? `repeat(${mobileCols}, 1fr)`
        : `repeat(${desktopCols}, 1fr)`;
    }
  }

  checkSlider();
  window.addEventListener("resize", checkSlider);
});

  } catch(e) { console.error(e); }
})();
})();
